import { createContext, useContext } from 'react';

const noop = () => {};

export interface PriceGridSettingsContextValue {
  alignPricesOnDecimal: boolean;
  onAlignPricesOnDecimalChange: (enabled: boolean) => void;
  isBBOEnabled: boolean;
  onBBOEnabledChange: (enabled: boolean) => void;
  showRFQ: boolean;
  onShowRFQChange: (enabled: boolean) => void;
  showLegMarketSelector: boolean;
  onShowLegMarketSelectorChange: (enabled: boolean) => void;
}

export const PriceGridSettingsContext = createContext<PriceGridSettingsContextValue>({
  alignPricesOnDecimal: true,
  onAlignPricesOnDecimalChange: noop,
  isBBOEnabled: false,
  onBBOEnabledChange: noop,
  showRFQ: true,
  onShowRFQChange: noop,
  showLegMarketSelector: true,
  onShowLegMarketSelectorChange: noop,
});

export function usePriceGridSettingsContext() {
  return useContext(PriceGridSettingsContext);
}
